import { useState, useRef } from "react";
import { Row, Col } from "react-bootstrap";
import Loader from "../../components/loader";
import UiButton from "../../components/button";
import TextInput from "../../components/textinput/TextInput";
import Web3 from "web3";
import { Liquidity, contractAddress } from "@verified-network/verified-sdk";

import ERC20ABI from "../../utils/abi/ERC20.json";
import {
  useSupportedTokens,
  useNetworkOptions,
} from "../../context/contractDataLoaderService";
import {
  SuccessToast,
  FailureToast,
  ToastOptions,
  networks,
} from "../../utils/constants";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAccount, useClient, useConnectorClient } from "wagmi";
import {
  getProviderNetwork,
  getProvider,
  getWeb3,
} from "../../utils/helpers/networks";
import { ethers, providers } from "ethers";
import { useGlobal } from "../../context/globalContext";
import { getAllVerifiedCashBalances } from "../../utils/helpers";

function ProvidesLiquidity(props) {
  const {
    userRole,
    userAddress,
    connectedChainId,
    connectedProvider,
    connectedSigner,
    connectedWeb3,
    verifiedWalletDetails,
  } = useGlobal();

  const address = userAddress;
  const account = userAddress;
  const chainId = connectedChainId;

  const provider = connectedProvider;

  const signer = connectedSigner;

  const web3 = connectedWeb3;
  let liquidityContract;
  if (provider && provider.getSigner && chainId && address) {
    liquidityContract = new Liquidity(
      signer,
      contractAddress[chainId].Liquidity,
    );
  }
  const [showModal, setShowModal] = useState(false);
  let { data } = useSupportedTokens();
  const { data: networkOptions } = useNetworkOptions();
  const [liquidityAmount, setLiquidityAmount] = useState("");
  const [tokenAmount, setTokenAmount] = useState("");
  const [loading, setLoading] = useState(false);
  const [changeContent, setChangeContent] = useState(false);
  const modalContent = useRef(null);

  const provideLiquidity = async () => {
    if (tokenAmount.length == 0) {
      alert("Enter token amount");
    }
    const selectedToken = data.find(
      (element) => element.tokenAddress === props.data.tokenAddress,
    );
    console.log("selectedToken", selectedToken);
    // const tokenContract = new web3.eth.Contract(
    //   ERC20ABI,
    //   props.data.tokenAddress,
    // );
    // const tokenDecimals = await tokenContract.methods.decimals().call();
    const amountFixed = ethers.utils.parseEther(tokenAmount)?.toString();

    setLoading(true);
    try {
      let paymentToken;

      if (
        verifiedWalletDetails &&
        Object?.keys(verifiedWalletDetails)?.length > 0
      ) {
        const cashTokens = await getAllVerifiedCashBalances(
          chainId,
          web3,
          account,
        );

        if (!cashTokens || cashTokens?.length === 0) {
          setLoading(false);
          toast.error(
            "No valid Cash Token on this network. Change network and try again.",
            ToastOptions,
          );

          return;
        }
        paymentToken = cashTokens[0];
        const txQuote = await liquidityContract._getMeeQuote(
          cashTokens[0]?.address,
          "provideLiquidity",
          [
            props.platformId,
            props.data.managerAddress,
            amountFixed,
            props.data.tokenAddress,
          ],
        );

        if (
          Number(cashTokens[0]?.balance) === 0 ||
          Number(txQuote?.amount) > Number(cashTokens[0]?.balanceFmt)
        ) {
          setLoading(false);
          toast.error(
            `Insufficient ${cashTokens[0]?.name} balance. You need at least: ${txQuote?.amount}  ${cashTokens[0]?.name} to proceed.`,
            ToastOptions,
          );

          return;
        }
      }

      await liquidityContract
        .provideLiquidity(
          props.platformId,
          props.data.managerAddress,
          amountFixed,
          props.data.tokenAddress,
          paymentToken?.address
            ? {
                paymentToken: paymentToken?.address,
                apiKey: process.env.REACT_APP_BICONOMY_MEE_KEY,
              }
            : {},
        )
        .then((res) => {
          setLoading(false);
          if (res?.status === 0) {
            const transactionLink = `${networks[chainId].blockExplorerUrls[0]}/tx/${res?.response?.hash}`;
            toast.success(SuccessToast(transactionLink), ToastOptions);
            setChangeContent(true);
            modalContent.current.innerHTML = "";
          } else {
            toast.error("Transaction Failed", ToastOptions);
          }
        });
    } catch (err) {
      let error = { err };
      console.log(error);
      setLoading(false);
      const transactionLink = `${networks[chainId].blockExplorerUrls[0]}/tx/${error.err?.transactionHash}`;
      toast.error("Transaction Failed", ToastOptions);
    }
  };
  return (
    <>
      {loading ? <Loader /> : null}
      {changeContent && (
        <UiButton
          onClick={() => {
            props.onModalHide();
          }}
          buttonVariant="primary"
          buttonClass="SignUpButton flex-1 ml-0"
          buttonText="Click to close this form&nbsp;&rarr;"
          type="submit"
        />
      )}
      <div className="d-grid gap-2" ref={modalContent}>
        <Row className="ml-1 align-items-center">
          <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
            <Col xs={{ span: 3, offset: 2 }} className="text-left">
              <b>Token amount</b>
              <div>
                Balance:{" "}
                {Number(props.data.liquidityContractBalance).toFixed(2) +
                  " " +
                  props.data.tokenName}
              </div>
            </Col>
            <Col className="pl-0" xs={5}>
              <TextInput
                placeholder={props.data.tokenName + " amount"}
                fieldType="number"
                required
                onChange={(e) => setTokenAmount(e.target.value)}
              />
            </Col>
          </Row>
          {/* <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
            <Col xs={{ span: 3, offset: 2 }} className="text-left">
              <b>Liquidity amount</b>
            </Col>
            <Col className="pl-0" xs={5}>
              <TextInput
                placeholder="Amount"
                fieldType="number"
                required
                onChange={(e) =>
                  setLiquidityAmount(web3.utils.toWei(e.target.value, "ether"))
                }
              />
            </Col>
          </Row> */}
          <Row className="mx-0 my-2 pl-0 width-100 align-items-center">
            <Col className="pl-0">
              <UiButton
                onClick={() => {
                  if (web3 && chainId && signer && account) {
                    provideLiquidity();
                  }
                }}
                buttonVariant="primary"
                buttonClass="SignUpButton flex-1 ml-0"
                buttonText="Provide Liquidity"
                type="submit"
              />
            </Col>
          </Row>
        </Row>
      </div>
    </>
  );
}

export function ProvideLiquidity(props) {
  return <ProvidesLiquidity {...props} />;
}
